import { AlertColor, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { InformationCard } from "../../../../components/InformationCard/InformationCard";
import { useProfile } from "../../../../context/ProfileProvider/useProfile";
import { QuickAccessWorkspace } from "../../../../model/UserModel";
import { WorkSpace } from "../../../../model/WorkSpaceModel";
import { GetOrgWorkSpaceAdmTrim, GetOrgWorkSpaceTrim } from "../../../../services/WorkSpaceServices";
import { GetOneOrganization } from "../../../../services/OrganizationServices";
import { IFavoriteModel } from "../../../../model/ItemModel";
import { getAllFavorites } from "../../../../services/favoriteServices";

interface IInformationCardComponent {
    setSeverity: (set: AlertColor) => void;
    setPopupMessage: (set: string | undefined) => void;
    setUserError: (set: boolean) => void;
}

export function InformationCardComponent({
    setSeverity,
    setPopupMessage,
    setUserError
}: IInformationCardComponent) {
    const { id } = useProfile();
    const { t } = useTranslation();
    const [favorites, setFavorites] = useState<IFavoriteModel[]>([]);
    const { nameOrg } = useParams();
    const [workspacesQuickAccessConst, setWorkspacesQuickAccessConst] = useState<QuickAccessWorkspace[]>([]);
    const [workspaces, setWorkspaces] = useState<WorkSpace[]>([]);
    const { adminSystem, id: userId } = useProfile();
    const [isOrgAdmin, setIsOrgAdmin] = useState<boolean>(false);
    const [loadingFavorites, setLoadingFavorites] = useState<boolean>(false);
    const [needGetFavorites, setNeedGetFavorites] = useState<boolean>(false);

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                setLoadingFavorites(true);
                const response = await getAllFavorites(nameOrg!, userId!);
                setFavorites(response.favoriteUserVO);
                setWorkspacesQuickAccessConst(response.quickAccessWorkspaceVO);
            } catch (error: any) {
                
            } finally {
                setLoadingFavorites(false);
                setNeedGetFavorites(false);
            }
        };

        fetchFavorites();
    }, [nameOrg!, userId, needGetFavorites]);

    useEffect(() => {
        if (nameOrg !== undefined) {
            GetOneOrganization(nameOrg)
            .then(data => {
                setIsOrgAdmin(data?.adminUsers?.includes(id!) ?? false);
            })
            .catch(err => {
                setPopupMessage(err.response.data);
                setSeverity("error");
            })
            .finally()

            if (adminSystem)
        {
            GetOrgWorkSpaceAdmTrim(nameOrg!, 0, 11, false)
            .then(data => {
                setWorkspaces(data);
              })
              .catch(err => {
                setPopupMessage(err.response.data);
                setSeverity("error");
                setUserError(true)
              });
        } else
        {
            GetOrgWorkSpaceTrim(nameOrg!, 0, 11, false)
            .then(data => {
              setWorkspaces(data);
            })
            .catch(err => {
              setPopupMessage(err.response.data);
              setSeverity("error");
              setUserError(true)
            });
        }
        }else{
            
        }
    }, [nameOrg])

    return (
        <Grid item xs={12} height="190px" display="flex" width="100%" justifyContent="space-between" mb="30px">
            <Grid item xs={6} paddingRight="30px">
                <InformationCard 
                    content={t("LoggedHome.QuickAccessContent")}
                    title={t("LoggedHome.QuickAccessTitle")}
                    type="quickAccess"
                    setPopupMessage={setPopupMessage}
                    setSeverity={setSeverity}
                    nameOrg={nameOrg!}
                    quickAccessWorkspaces={workspacesQuickAccessConst}
                    setQuickAccessWorkspaces={setWorkspacesQuickAccessConst}
                    adminSystem={adminSystem!}
                    isOrgAdmin={isOrgAdmin}
                    loadingFavorites={loadingFavorites}
                    favorites={favorites}
                    setLoadingFavorites={setLoadingFavorites}
                    setNeedGetFavorites={setNeedGetFavorites}
                />
            </Grid>
            <Grid item xs={6}>
                <InformationCard
                    content={t("LoggedHome.OrganizationsContent")}
                    title="Workspace"
                    type="organizations"
                    quickAccessWorkspaces={workspacesQuickAccessConst}
                    setPopupMessage={setPopupMessage}
                    setSeverity={setSeverity}
                    nameOrg={nameOrg!}
                    setQuickAccessWorkspaces={setWorkspacesQuickAccessConst}
                    adminSystem={adminSystem!}
                    isOrgAdmin={isOrgAdmin}
                    loadingFavorites={loadingFavorites}
                    favorites={favorites}
                    setLoadingFavorites={setLoadingFavorites}
                    setNeedGetFavorites={setNeedGetFavorites}
                />
            </Grid>
        </Grid>
    )
}